import { render } from "./EditMinne.vue?vue&type=template&id=6bd52045&scoped=true"
import script from "./EditMinne.vue?vue&type=script&lang=js"
export * from "./EditMinne.vue?vue&type=script&lang=js"

import "./EditMinne.vue?vue&type=style&index=0&id=6bd52045&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd52045"]])

export default __exports__